import Vue from 'vue'
import Router from 'vue-router'
import VueGtag from 'vue-gtag'
import HelloWorld from '@/components/HelloWorld'
import SiteTop from '@/components/pc/SiteTop'
import History from '@/components/pc/History'
import DelayCertificate from '@/components/pc/DelayCertificate'
import Outline from '@/components/pc/Outline'
import Maintenance from '@/components/pc/Maintenance'
import PageNotFound from '@/components/pc/PageNotFound'

import SpSiteTop from '@/components/sp/SpSiteTop'
import SpLineList from '@/components/sp/SpLineList'
import SpOutline from '@/components/sp/SpOutline'
import SpDelayCertificate from '@/components/sp/SpDelayCertificate'
import SpHistory from '@/components/sp/SpHistory'
import SpMaintenance from '@/components/sp/SpMaintenance'
import SpPageNotFound from '@/components/sp/SpPageNotFound'
import store from '../store'
import json from '../json'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/pc/',
      name: 'SiteTop',
      component: SiteTop
    },
    {
      path: '/pc/guideline/outline',
      name: 'Outline',
      component: Outline
    },
    {
      path: '/pc/maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/pc/:areaId',
      name: 'SiteTopArea',
      component: SiteTop
    },
    {
      path: '/pc/history/:areaId/:lineId',
      name: 'History',
      component: History
    },
    {
      path: '/pc/delay-certificate/:today/:areaId/:lineId/:timeZoneId',
      name: 'TodayDelayCertificate',
      component: DelayCertificate
    },
    {
      path: '/pc/delay-certificate/:today/:areaId/:lineId/:targetDate/:timeZoneId',
      name: 'HistoryDelayCertificate',
      component: DelayCertificate
    },
    {
      path: '/sp/',
      name: 'SpSiteTop',
      component: SpSiteTop
    },
    {
      path: '/sp/guideline/outline',
      name: 'SpOutline',
      component: SpOutline
    },
    {
      path: '/sp/maintenance',
      name: 'SpMaintenance',
      component: SpMaintenance
    },
    {
      path: '/sp/:areaId',
      name: 'SpLineList',
      component: SpLineList
    },
    {
      path: '/sp/history/:areaId/:lineId',
      name: 'SpHistory',
      component: SpHistory
    },
    {
      path: '/sp/delay-certificate/:today/:areaId/:lineId/:timeZoneId',
      name: 'SpTodayDelayDelayCertificate',
      component: SpDelayCertificate
    },
    {
      path: '/sp/delay-certificate/:today/:areaId/:lineId/:targetDate/:timeZoneId',
      name: 'SpHistoryDelayCertificate',
      component: SpDelayCertificate
    },
    {
      path: '/sp/*',
      name: 'SpPageNotFound',
      component: SpPageNotFound
    },
    {
      path: '/*',
      name: 'PageNotFound',
      component: PageNotFound
    }
  ]
})

const gotoMaintenance = (isSP) => {
  if (isSP) {
    document.location.href = '/sp/maintenance'
  } else {
    document.location.href = '/pc/maintenance'
  }
}

const gotoSiteTop = (isSP) => {
  if (isSP) {
    document.location.href = '/sp/'
  } else {
    document.location.href = '/pc/'
  }
}

const checkMaintenance = (to, next) => {
  const isSP = /(android|ip(hone|od|ad))/i.test(navigator.userAgent || navigator.vendor || window.opera)
  json.get('/ope/maintenance/maintenance.dat', undefined, true)
    .then(response => {
      if (response.data === 1) {
        if (to.name !== 'Maintenance' && to.name !== 'SpMaintenance') {
          gotoMaintenance(isSP)
        } else {
          next()
        }
      } else {
        if (to.name === 'Maintenance' || to.name === 'SpMaintenance') {
          gotoSiteTop(isSP)
        } else {
          next()
        }
      }
    })
    .catch(() => {
      if (to.name === 'Maintenance' || to.name === 'SpMaintenance') {
        gotoSiteTop(isSP)
      } else {
        next()
      }
    })
}

const showLoadingSpinner = (to, from, isSP) => {
  if (isSP || from.matched.length === 0 || to.matched.length === 0 || from.matched[0].path !== to.matched[0].path) {
    store.commit('loading/setStatus', true)
  }
}

const topPath = (isSP) => isSP ? '/sp' : '/pc'

router.beforeEach((to, from, next) => {
  var isSP = /(android|ip(hone|od|ad))/i.test(navigator.userAgent || navigator.vendor || window.opera)
  store.commit('scroll/setShowPageBtn', false)
  // ページ移行の時、マスタをリロード
  store.commit('areaLine/setStatus', '')
  store.commit('timeZone/setStatus', '')
  showLoadingSpinner(to, from, isSP)
  checkMaintenance(to, () => {
    if (to.name === 'PageNotFound' || to.name === 'SpPageNotFound') {
      if (/^\/index\?aid=1/.test(to.fullPath)) {
        // 旧パース変更
        // http://delay.trafficinfo.westjr.co.jp/index?aid=1 -> https://dev-delay.trafficinfo.westjr.co.jp/pc/2
        document.location.href = to.fullPath.replace(/^\/index\?aid=1/g, topPath(isSP) + '/2')
      } else if (/^\/index\?aid=2/.test(to.fullPath)) {
        // 旧パース変更
        // http://delay.trafficinfo.westjr.co.jp/index?aid=2 -> https://dev-delay.trafficinfo.westjr.co.jp/pc/5
        document.location.href = to.fullPath.replace(/^\/index\?aid=2/g, topPath(isSP) + '/5')
      } else if (/^\/index/.test(to.fullPath) ||
        /^\/history/.test(to.fullPath) ||
        /^\/line/.test(to.fullPath) ||
        /^\/timeline/.test(to.fullPath) ||
        /^\/outline/.test(to.fullPath)) {
        // 旧パース変更
        // http://delay.trafficinfo.westjr.co.jp/history?aid=1&lid=1 -> https://dev-delay.trafficinfo.westjr.co.jp/pc/history/2/2
        // http://delay.trafficinfo.westjr.co.jp/line?aid=1&lid=2&tid=1&did=153387 -> https://dev-delay.trafficinfo.westjr.co.jp/
        // http://delay.trafficinfo.westjr.co.jp/line/past?aid=1&lid=1&tid=1&did=153001 -> https://dev-delay.trafficinfo.westjr.co.jp/
        document.location.href = topPath(isSP)
      } else if (isSP && to.name !== 'SpPageNotFound') {
        next({ name: 'SpPageNotFound' })
      } else if (!isSP && to.name !== 'PageNotFound') {
        next({ name: 'PageNotFound' })
      } else {
        next()
      }
    } else {
      if (isSP && (/^\/pc/.test(to.path) || to.path === '/')) {
        document.location.href = to.fullPath.replace(/(^\/pc|^\/)/, topPath(isSP))
      } else if (!isSP && (/^\/sp/.test(to.path) || to.path === '/')) {
        document.location.href = to.fullPath.replace(/(^\/sp|^\/)/, topPath(isSP))
      } else {
        next()
      }
    }
  })
})

Vue.use(VueGtag, {
  config: {id: process.env.VUE_APP_GTAG_ID}
}, router)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js